<template>
  <div class="stat-prices stat-block pt-4 pb-3">
    <stat-loader :display="loader"></stat-loader>

    <div class="container">

      <div class="row">
        <div class="col-7">
          <h2 class="mb-4 pb-1 pt-1">Jämförelse mellan Spotpris, Marknadspris samt ert avtalspris</h2>
        </div>
        <div class="col-5 text-right scales-nav mt-3">
          <span v-for="{name, handle} in scales" :class="{active: scale === handle}" class="scale-item ml-3">
            <span @click="scale = handle">{{ name }}</span>
          </span>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-8 categories-nav">
          <stat-price-category
            :key="category.id"
            :name="category.name"
            :id="category.id"
            v-model="category_id"
            v-for="category in areaCategories"/>

          <div class="clearfix"></div>
        </div>
        <div class="col-4 contract-types">
          <select class="form-control" v-model="contract_type">
            <option v-for="type in contractTypes" :value="type.handle">
              {{ type.name }}
            </option>
          </select>
        </div>
      </div>

      <div id="chart" v-if="loaded">
        <apexchart type=line height=350 :options="chartOptions" :series="series"/>
      </div>

    </div>
  </div>
</template>

<script>

  import {mapState} from "vuex"
  import StatPriceCategory from "./Category"
  import {areaCategories, contractTypes, statisticsScales} from "./../../../../app/services/Data/GeneralData"
  import StatLoader from "../Partials/Loader"
  import sv from "./../../../../../translations/apexcharts/sv"
  import DateMixin from "../../../../app/mixins/helpers/DateMixin"

  export default {
    name: "StatPrices",
    components: {StatLoader, StatPriceCategory},
    mixins: [
      DateMixin
    ],
    computed: {
      ...mapState({
        loaded: state => state.statistics.prices.loaded,
        statistics: state => state.statistics.prices.data,
        company: state => state.auth.company,
      }),
      areaCategories() {
        let output = areaCategories()

        output.unshift({
          id: null,
          name: 'Hela landet'
        })

        return output
      },
      contractTypes() {
        let output = contractTypes()

        output.unshift({
          handle: null,
          name: 'Alla kontraktstyper'
        })

        return output
      },
      scales() {
        return statisticsScales()
      },
      series() {
        return [
          {
            name: 'Spotpris',
            data: this.statistics.spot.map(attributes => attributes.price)
          },
          {
            name: 'Marknadspris',
            data: this.statistics.market.map(attributes => attributes.price)
          },
          {
            name: `Ert avtalspris (${this.company.name})`,
            data: this.statistics.company.map(attributes => attributes.price)
          }
        ]
      },
      labels() {
        let output = []

        for (let label of this.statistics.labels) {

          let text

          switch (this.scale) {
            case 'month':
              text = this.monthTextYear(label)
              break
            case 'week':
            case 'day':
            default:
              text = this.dayMonth(label)
              break
          }

          output.push(text)
        }

        return output
      },
      chartOptions() {
        return {
          chart: {
            defaultLocale: 'sv',
            locales: [
              sv
            ],
            height: 350,
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            },
          },
          xaxis: {
            categories: this.labels,
          }
        }
      }
    },
    watch: {
      async category_id(value) {
        await this.fetch()
      },
      async contract_type(value) {
        await this.fetch()
      },
      async scale(value) {
        await this.fetch()
      }
    },
    async mounted() {
      await this.fetch()
    },
    methods: {
      async fetch() {
        this.loader = true

        const input = {
          scale: this.scale,
          category_id: this.category_id,
          contract_type: this.contract_type,
        }

        await this.$store.dispatch('fetchPricesCompare', input)

        this.loader = false
      }
    },
    data() {
      return {
        scale: 'day',
        category_id: null,
        contract_type: null,
        loader: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Prices/Index.vue